<template>
  <div>
    <Dialog_EditGroup></Dialog_EditGroup>
    <Dialog_EditSaleBusinessCard></Dialog_EditSaleBusinessCard>
    <div class="mainLeft" v-if="permission">
      <MainToolBar @collapseFriendGroup="collapseFriendGroup"></MainToolBar>
      <PCGroupAndFriendView></PCGroupAndFriendView>
    </div>

    <div class="mainRight" v-show="permission">
      <!-- 動態產生聊天室 -->
      <iframe
        id="ifrmname"
        name="ifrmname"
        style="width: calc(100% - 372px); height: 100%"
        :src="ChatHtml"
      ></iframe>
      <div
        :class="collapsebarCustInfoStyle"
        @click="collapseCustInfo"
        style="cursor: pointer"
      ></div>
      <transition name="fade">
        <!-- 客戶頭像 -->
        <SocialLeadPairedBasisInfo
          :socialLeadId="socialLeadId"
          :staffID="mode.staff.staffid"
          :tutorChatToken="mode.token"
          v-show="CustInfoDisplay"
        ></SocialLeadPairedBasisInfo>
      </transition>
    </div>

    <!-- 首頁 -->
    <div class="mainRight" v-show="permission && showWording">
      <div class="infoPage">
        <div class="dialogBox">
          <h1></h1>
          <h2>歡迎使用SCRM Portal</h2>
          <p></p>
        </div>
      </div>
    </div>
    <Info
      :message="wording[1]"
      :message2="wording[2]"
      v-if="!permission"
      style="position: fixed"
    ></Info>
    <CSS></CSS>
    <WebPush></WebPush>
  </div>
</template>

<script>
import CSS from "../components/Main/CSS.vue";
import MainToolBar from "../components/Main/MainToolBar.vue";
import PCGroupAndFriendView from "../views/PCGroupAndFriendView.vue";
import ChatContainer from "../components/Main/ChatContainer.vue";
import SocialLeadPairedBasisInfo from "../components/Main/SocialLeadPairedBasisInfo.vue";
import WebPush from "@/components/Main/WebPushForPC";
import Info from "@/components/Main/Info";

import { ChatContainerHandler } from "@/handler/ChatContainerHandler.js";
import { TutorChatTokenHandler } from "@/handler/TutorChatTokenHandler.js";
import Dialog_EditGroup from "@/components/Main/Dialog_EditGroup.vue";
import Dialog_EditSaleBusinessCard from "@/components/Main/Dialog_EditSaleBusinessCard.vue";
import store from "../vuex/store_friendList.js";
import http from "../http.js";
import store_groupList from "../vuex/store_groupList.js";
import qs from "qs";

$.urlParam = function (name, url) {
  var results = new RegExp("[?&]" + name + "=([^&#]*)").exec(url);
  return results[1] || 0;
};

export default {
  name: "MainView",
  components: {
    CSS,
    SocialLeadPairedBasisInfo,
    ChatContainer,
    MainToolBar,
    PCGroupAndFriendView,
    Info,
    WebPush,
    Dialog_EditGroup,
    Dialog_EditSaleBusinessCard,
  },
  data() {
    return {
      wording: ["歡迎使用SCRM Portal", "Warning!", "此功能僅公司內部使用"],
      permission: false,
      showWording: true,
      staff: [],
      mode: {
        type: "PC",
        token: "",
        staff: [],
      },
      FriendDisplay: true, //好友列表收合
      GroupDisplay: true, //群組列表收合
      CustInfoDisplay: true, //客戶畫像收合
      group: [],
    };
  },
  mounted() {
    //$("#mainRight").css({ left: 110, width: "calc(100% - 110px)" });
  },
  created() {
    document.title = "SCRM Portal";
    this.mode.staff = this.GetLoginStaff();

    var ticket = this.GetTicket();

    this.mode.token = TutorChatTokenHandler.getTctToken(ticket);

    this.permission = this.mode.staff != null;

    if (this.permission == false) {
      return false;
    }
    if (this.$route.query.user != undefined) {
      var that = this;
      var socialLeadId = this.$route.query.user;
      //取得客戶渠道
      http
        .post(
          "Chat/GetChatRooms",
          qs.stringify({
            SocialLeadId: socialLeadId,
            StaffID: that.mode.staff.staffid,
          })
        )
        .then(function (response) {
          var data = response.data.Result;

          //找到預設渠道
          var obj = data.filter(function (elem) {
            if (elem.isPrefer == true) return elem;
          });

          if (obj.length > 0) {
            var chatRoomId = obj[0].Id;
            store.dispatch("selectSocialLead", { socialLeadId, chatRoomId });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  },
  methods: {
    OpenGroup: function () {
      this.GroupDisplay = true;
      //this.FriendDisplay = true;
      this.setMainRight();
    },
    setMainRight: function () {
      var iframe = document.getElementById("ifrmname");
      if (iframe != null) {
        iframe.style.width = "calc(100% - 372px)";
      }
      $(".collapsebarCustInfo ").css({ right: 350 });
      if (this.GroupDisplay) {
        $(".mainRight").css({ left: 490, width: "calc(100% - 490px)" });

        if (!this.CustInfoDisplay) {
          if (iframe != null) {
            iframe.style.width = "calc(100% - 22px)";
          }
          $(".collapsebarCustInfo ").css({ right: 0 });
        }
      } else {
        $(".mainRight").css({ left: 90, width: "calc(100% - 90px)" });

        if (!this.CustInfoDisplay) {
          if (iframe != null) {
            iframe.style.width = "calc(100% - 22px)";
          }
          $(".collapsebarCustInfo ").css({ right: 0 });
        }
      }
    },
    collapseCustInfo: function () {
      this.CustInfoDisplay = !this.CustInfoDisplay;
      this.setMainRight();
    },
    collapsemouseOver: function () {},
    collapseFriendGroup: function () {
      store_groupList.dispatch("unreadGroupShow");
      //this.GroupDisplay = !this.GroupDisplay;
      //this.setMainRight();
    },
    collapseFriendList: function () {
      this.FriendDisplay = !this.FriendDisplay;
      this.setMainRight(".mainRight");
    },
  },
  computed: {
    collapsebarStyle() {
      if (this.FriendDisplay) {
        return "collapsebar";
      } else {
        return "collapsebar close";
      }
    },
    collapsebarCustInfoStyle() {
      if (this.CustInfoDisplay) {
        return "collapsebarCustInfo close";
      } else {
        return "collapsebarCustInfo ";
      }
    },
    socialLeadId() {
      return this.$route.query.user;
    },
    ChatHtml: {
      get: function () {
        var flag = store.state.reload;

        var socialLeadId = store.state.socialLeadId;
        if (
          socialLeadId == null ||
          socialLeadId == undefined ||
          socialLeadId == ""
        ) {
          return "";
        }

        var chatRoomId = store.state.chatRoomId;
        if (chatRoomId == null || chatRoomId == undefined || chatRoomId == "") {
          return "";
        }

        var data = ChatContainerHandler.GeneralChatRoomUrl(
          chatRoomId,
          this.mode.staff.staffid
        );

        var token = $.urlParam("token", data);
        var url = "?t=" + Math.random() + "/#/Chat2?token=" + token;
        window.location.href = "/#/Main2?user=" + socialLeadId;
        this.showWording = false;
        return url;
      },
    },
  },
};
</script>
<style>
.chatFrame {
  width: 100%;
  height: 100%;
}

.collapsebarGroup {
  width: 22px;
  height: 100%;
  background: #f5f5f5;
  position: absolute;
  left: 88px;
  top: 0;
  cursor: pointer;
  transition: all 0.3s;
  border: 1px solid #ea9496;
  z-index: 9;
}

.collapsebarGroup:hover {
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.2);
  z-index: 9999;
}

.collapsebarGroup:before {
  content: "";
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 6px 6px 6px 0;
  border-color: transparent #d06166 transparent transparent;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}

.collapsebarGroup.close:before {
  border-width: 6px 0 6px 6px;
  border-color: transparent transparent transparent #d06166;
}

.collapsebar {
  width: 22px;
  height: 100%;
  background: #ccc;
  position: absolute;
  left: 378px;
  top: 0;
  cursor: pointer;
  transition: background 0.3s;
}

.collapsebar:hover {
  background: #aaa;
}

.collapsebar:before {
  content: "";
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 9px 8px 9px 0;
  border-color: transparent #fff transparent transparent;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}

.collapsebar.close:before {
  border-width: 9px 0 9px 8px;
  border-color: transparent transparent transparent #fff;
}

.collapsebarCustInfo {
  width: 22px;
  height: 100%;
  background: #f5f5f5;
  position: absolute;
  right: 350px;
  top: 0;
  cursor: pointer;
  border: 1px solid #ea9496;
  transition: all 1s;
  -moz-transition: all 1s;
  -webkit-transition: all 1s;
  -o-transition: all 1s;
}

.collapsebarCustInfo:hover {
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.2);
  z-index: 9999;
}

.collapsebarCustInfo:before {
  content: "";
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 6px 6px 6px 0;
  border-color: transparent #d06166 transparent transparent;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}

.collapsebarCustInfo.close:before {
  border-width: 6px 0 6px 6px;
  border-color: transparent transparent transparent #d06166;
}

#ifrmname {
  transition: all 1s;
  -moz-transition: all 1s;
  -webkit-transition: all 1s;
  -o-transition: all 1s;
}
</style>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/MainView.vue